import { AssetType } from 'config/consts';
import React from 'react';
import {
  AssetTypeKey,
  assetTypeKeyToString,
} from 'components/features/utils/assetType';
import { WhatIsIncludeAsstsModal } from 'components/features/modal/WhatIsIncludeAsstsModal';
import { useModal } from 'hooks/useModal';

const WhatIsIncludeAsstsModalButtonInternal = ({
  assetTypeKey,
  title,
  modalStates,
}: {
  assetTypeKey: AssetTypeKey;
  title: string;
  modalStates: {
    isShowModal: boolean;
    hideModal: () => void;
    onClick: () => void;
  };
}) => {
  const modalIconClass = 'icon-help_outline';
  const { onClick } = modalStates;
  return (
    <>
      <div
        className="flex flex-row items-center cursor-pointer"
        {...{
          onClick: e => {
            e.stopPropagation();
            onClick();
          },
        }}>
        <div className="mr-2">{title}</div>
        <i className={`${modalIconClass} ml-1 text-bluegray-400 text-sm`} />
      </div>
      <WhatIsIncludeAsstsModal
        {...{
          isShowModal: modalStates.isShowModal,
          hideModal: modalStates.hideModal,
          assetTypeKey,
        }}
      />
    </>
  );
};

export const WhatIsIncludeAsstsModalButton = ({
  assetTypeKey,
  title,
}: {
  assetTypeKey: AssetTypeKey;
  title: string;
}) => {
  const [isShowModal, { hideModal, showModal }] = useModal();

  return (
    <>
      <WhatIsIncludeAsstsModalButtonInternal
        {...{
          assetTypeKey,
          title,
          modalStates: {
            isShowModal,
            hideModal,
            onClick: showModal,
          },
        }}
      />
    </>
  );
};

const AssetOrganizedPortfolioTitle = ({
  assetTypeKey,
  assetName,
  children,
}: {
  assetTypeKey: AssetTypeKey;
  assetName?: string;
  children: React.ReactNode;
}) => {
  const title = assetName ?? assetTypeKeyToString(assetTypeKey);

  const isShowModal =
    assetTypeKey === AssetType['預金_MRF'] ||
    assetTypeKey === AssetType['その他'];

  return (
    <>
      <div className="mb-2 flex flex-row items-center text-gray-500">
        <div className="flex flex-row text-base leading-6 text-gray-700 font-bold">
          {title}
          {isShowModal && (
            <WhatIsIncludeAsstsModalButton
              assetTypeKey={assetTypeKey}
              title={''}
            />
          )}
        </div>
        {children}
      </div>
    </>
  );
};

export const AssetOrganizedPortfolioContainer = ({
  assetTypeKey,
  assetName,
  children,
  SubInformation,
}: {
  assetTypeKey: AssetTypeKey;
  assetName?: string;
  children: React.ReactNode;
  SubInformation: () => React.ReactElement;
}) => {
  return (
    <>
      <div className="mt-6">
        <AssetOrganizedPortfolioTitle {...{ assetTypeKey, assetName }}>
          <SubInformation />
        </AssetOrganizedPortfolioTitle>
        {children}
      </div>
    </>
  );
};
